var render = function () {
  var _vm$bookingPreset$nam, _vm$bookingPreset$nam2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": _vm.isBookingCenter ? '' : 'BookingSelectList',
      "extra-items": _vm.isBookingCenter ? ['登記預約中心', {
        text: (_vm$bookingPreset$nam = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam !== void 0 ? _vm$bookingPreset$nam : '',
        to: 'BookingCenterBookingList',
        params: _vm.$route.params.id
      }, _vm.isReadOnly ? '檢視預約' : _vm.isEditing ? '編輯預約' : '新增預約'] : [{
        text: (_vm$bookingPreset$nam2 = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam2 !== void 0 ? _vm$bookingPreset$nam2 : '',
        to: 'BookingList',
        params: _vm.$route.params.id
      }, _vm.isReadOnly ? '檢視預約' : _vm.isEditing ? '編輯預約' : '新增預約']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "preserve-spacing-for-datetime-picker"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "檢視預約" : _vm.isEditing ? "編輯預約" : "新增預約") + " - " + _vm._s(_vm.bookingPreset.name) + " ")]), _c('b-form-group', {
    attrs: {
      "label": "預約號碼",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_c('label', {
    staticClass: "col-form-label",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_vm._v(_vm._s(_vm.booking.booking_number))])]), _c('b-form-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": '預約會員',
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "9"
    }
  }, [_vm.customer ? _c('div', {
    staticClass: "d-flex align-items-center py-2 staff-info"
  }, [_c('b-avatar', {
    staticClass: "mx-2",
    attrs: {
      "src": _vm.customer.avatar_url
    }
  }), _c('div', {
    staticClass: "mr-auto font-weight-bold text-nowrap text-truncate"
  }, [_vm._v(" " + _vm._s(_vm.customer.name) + " "), _c('span', {
    staticClass: "staff-list-info"
  }, [_vm._v(" " + _vm._s(_vm.customer.email)), _c('br'), _vm._v(" " + _vm._s(_vm.displayCustomerInfo(_vm.customer)) + " ")])])], 1) : _vm._e(), !_vm.isReadOnly ? _c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "add-button-text": _vm.addCustomerButtonText,
      "sourceType": 'line'
    },
    on: {
      "bind": _vm.handleSelectCustomer
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "sorted-fields"
  }, [_vm.bookingPreset.type === 'wizard' && _vm.dataModel.branchSelectionIsEnabled ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.branch
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店",
      "label-for": "staff"
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.isReadOnly || _vm.disabledBranchSelect
    },
    on: {
      "input": _vm.handleBranchChange
    },
    model: {
      value: _vm.booking.select_branch,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "select_branch", $$v);
      },
      expression: "booking.select_branch"
    }
  })], 1) : _vm._e(), _vm.bookingPreset.type === 'wizard' && _vm.dataModel.staffSelectionIsEnabled ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.staff
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工",
      "label-for": "staff"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.booking.staff ? _c('b-form-text', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_vm._v(" " + _vm._s(_vm.booking.staff.name) + " ")]) : _vm._e(), !_vm.isReadOnly ? _c('b-button', {
    staticClass: "mb-xl-0",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.booking.branch_id
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.staffSelection.show();
      }
    }
  }, [_vm.isFetchingStaffs ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 選擇員工 ")], 1) : _vm._e()], 1)]) : _vm._e(), _vm.bookingPreset.type === 'wizard' && _vm.dataModel.serviceFieldId ? _c('b-form-group', {
    style: {
      order: _vm.fieldOrder.service
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "服務",
      "label-for": "service"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoadingServices
    }
  }, [_vm.canMultipleSelect ? _c('div', [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.handleServiceSelected
    },
    model: {
      value: _vm.booking.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "service_id", $$v);
      },
      expression: "booking.service_id"
    }
  })], 1) : _c('div', [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.isReadOnly
    },
    on: {
      "input": _vm.handleServiceSelected
    },
    model: {
      value: _vm.booking.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.booking, "service_id", $$v);
      },
      expression: "booking.service_id"
    }
  })], 1)])], 1) : _vm._e()], 1), _c('DynamicFormDashboard', {
    ref: "dynamicForm",
    attrs: {
      "input-subjects": _vm.visibleSubjects
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  }), false === _vm.hasSetUpFieldMappingForStartAt ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間",
      "label-for": "start_at"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "id": "start_at",
      "hasError": _vm.deepGet(_vm.v$, 'start_at.$error'),
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.start_at,
      callback: function callback($$v) {
        _vm.start_at = $$v;
      },
      expression: "start_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'start_at.$error')
    }
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1) : _vm._e(), _vm.shouldShowDefaultEndAtField ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間",
      "label-for": "end_at"
    }
  }, [_c('AppDateTimePicker', {
    attrs: {
      "id": "end_at",
      "hasError": _vm.deepGet(_vm.v$, 'end_at.$error'),
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.end_at,
      callback: function callback($$v) {
        _vm.end_at = $$v;
      },
      expression: "end_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'end_at.$error')
    }
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)], 1)])], 1)], 1)])]), _c('SelectStaffStatic', {
    ref: "staffSelection",
    attrs: {
      "staffs": _vm.availableStaffs,
      "is-loading": _vm.isFetchingStaffs
    },
    on: {
      "selected": _vm.handleStaffSelected
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }